<template>
    <!-- <nav id="nav-bar" class="d-flex">-->
        <!--<h1><a href="/" class="logo"></a></h1>-->
        <!--<a href="/" class="help-button">Help</a>-->
    <!--</nav> -->
    <header id="header" class="navbar navbar-dark sticky-top flex-md-nowrap">
        <a id="logo-link" href="/" class="navbar-brand col-md-3 col-lg-2 me-0">
            <img id="logo-1" src="/themes/web/assets/images/logo.png" alt="">
        </a>

        <!-- <a class="header-help" href="/faq">
            <button class="help-button">
                <i class="lisa-icon-header-help" style="margin-right:6px"></i> {{$t('help')}}
            </button>
        </a> -->
    </header>
</template>

<script>
    import axios from 'axios'
    import {mapGetters} from 'vuex'

    export default {
        name: "NavBarAuth",

        data() {
            return {
                user: {name: 'Guest'},
                locate: 'vi',
            };
        },

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },

        created() {
            this.fetch();
            this.locate = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
        },
        methods: {
            fetch() {

            },

            setLocate(e) {
                localStorage.setItem('lang', e);
                this.locate = e;
                // document.location = "/";
                location.reload();
                //this.$store.dispatch('setLang', lang);

                // e.preventDefault();
            }
        }
    }
</script>

<style scoped>
    #nav-bar{
        justify-content: space-between;
        align-items: center;
    }
    .help-button {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        text-align: center;
        margin-right: 20px;
        background: linear-gradient(180deg, #20C997 0%, #28A745 100%);
        box-shadow: 4px 2px 20px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        padding: 8px 20px;
        border: none;
    }
    #header{
        margin-bottom: 0px;
        padding: 0 30px 0 20px;
    }
    .navbar{
        height: 84px;
    }
    #logo-1{
        /* height: 115px; */
        width: 100%;
    }
</style>
